import { render, staticRenderFns } from "./ExternalMyCouponsPage.vue?vue&type=template&id=49607e43&"
import script from "./ExternalMyCouponsPage.vue?vue&type=script&lang=ts&"
export * from "./ExternalMyCouponsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports